import React, { Component } from "react";
import { connect } from "react-redux";
import clone from "clone";
import { Link } from "react-router-dom";
import { Layout } from "antd";
import options from "./options";

import Scrollbars from "../../components/utility/customScrollBar.js";
import Menu from "../../components/uielements/menu";
import IntlMessages from "../../components/utility/intlMessages";
import SidebarWrapper from "./sidebar.style";
import appActions from "../../redux/app/actions";
import themes from "../../settings/themes";
import { themeConfig } from "../../settings";
import "./customStyle.css";

const SubMenu = Menu.SubMenu;
const { Sider } = Layout;

const { toggleOpenDrawer, changeOpenKeys, changeCurrent, toggleCollapsed } =
  appActions;
const stripTrailingSlash = (str) => {
  if (str.substr(-1) === "/") {
    return str.substr(0, str.length - 1);
  }
  return str;
};

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
  }
  handleClick(e) {
    this.props.changeCurrent([e.key]);
    const isNarrow = typeof window !== "undefined" && window.innerWidth <= 991;
    const sidebarOpen = !this.props.app.collapsed;
    if (isNarrow && sidebarOpen && !this._closingMobile) {
      this._closingMobile = true;
      // Reset the guard in a microtask so a duplicate handleClick from the
      // outer Menu's onClick (firing right after the inner Link's onClick)
      // is ignored — but later clicks still work.
      Promise.resolve().then(() => {
        this._closingMobile = false;
      });
      this.props.toggleCollapsed();
    }
  }
  onOpenChange(newOpenKeys) {
    const { app, changeOpenKeys } = this.props;
    const latestOpenKey = newOpenKeys.find(
      (key) => !(app.openKeys.indexOf(key) > -1)
    );
    const latestCloseKey = app.openKeys.find(
      (key) => !(newOpenKeys.indexOf(key) > -1)
    );
    let nextOpenKeys = [];
    if (latestOpenKey) {
      nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(latestOpenKey);
    }
    if (latestCloseKey) {
      nextOpenKeys = this.getAncestorKeys(latestCloseKey);
    }
    changeOpenKeys(nextOpenKeys);
  }
  getAncestorKeys = (key) => {
    const map = {
      sub3: ["sub2"],
    };
    return map[key] || [];
  };
  getMenuItem = ({ singleOption, submenuStyle, submenuColor }) => {
    const { key, label, iconComponent: IconComponent, leftIcon, children } = singleOption;

    const url = stripTrailingSlash(this.props.url);
    if (children) {
      return (
        <SubMenu
          key={key}
          title={
            <span className="isoMenuHolder" style={submenuColor}>
              <div style={{ marginRight: 10, display: "flex", alignItems: "center" }}>
                {IconComponent ? (
                  <IconComponent className="sidebar-menu-icons" style={{ fontSize: 18 }} />
                ) : (
                  <img
                    src={require("../../image/dpo-images/Icons/" + leftIcon)}
                    className="sidebar-menu-icons"
                    alt=""
                  />
                )}
              </div>
              <span className="nav-text">
                <IntlMessages id={label} />
              </span>
            </span>
          }
        >
          {children.map((child) => {
            const linkTo = child.withoutDashboard
              ? `/${child.key}`
              : `${url}/${child.key}`;
            return (
              <Menu.Item style={submenuStyle} key={child.key}>
                <Link style={submenuColor} to={linkTo} onClick={() => this.handleClick({ key: child.key })}>
                  <IntlMessages id={child.label} />
                </Link>
              </Menu.Item>
            );
          })}
        </SubMenu>
      );
    }
    return (
      <Menu.Item key={key}>
        <Link to={`${url}/${key}`} onClick={() => this.handleClick({ key })}>
          <span className="isoMenuHolder" style={submenuColor}>
            <div style={{ marginRight: 10, display: "flex", alignItems: "center" }}>
              {IconComponent ? (
                <IconComponent className="sidebar-menu-icons" style={{ fontSize: 18 }} />
              ) : (
                <img
                  src={require("../../image/dpo-images/Icons/" + leftIcon)}
                  className="sidebar-menu-icons"
                  alt=""
                />
              )}
            </div>
            <span className="nav-text">
              <IntlMessages id={label} />
            </span>
          </span>
        </Link>
      </Menu.Item>
    );
  };

  renderGroupedMenu = ({ submenuStyle, submenuColor }) => {
    const { app } = this.props;
    const collapsed = clone(app.collapsed) && !clone(app.openDrawer);
    const isNarrow =
      typeof window !== "undefined" && window.innerWidth <= 991;
    // On narrow screens the sidebar slides off-screen as an overlay — keep
    // the menu in "inline" mode the whole time so we don't churn submenu
    // portals on every open/close (which races with route changes and
    // throws "Failed to execute 'removeChild'").
    const mode = collapsed && !isNarrow ? "vertical" : "inline";

    return (
      <Menu
        onClick={this.handleClick}
        theme="dark"
        className="isoDashboardMenu"
        mode={mode}
        openKeys={collapsed ? [] : app.openKeys}
        selectedKeys={app.current}
        onOpenChange={this.onOpenChange}
      >
        {options.map((group) => (
          <Menu.ItemGroup
            key={group.groupLabel}
            title={
              <span className="sidebar-group-label">{group.groupLabel}</span>
            }
          >
            {group.items.map((singleOption) =>
              this.getMenuItem({ submenuStyle, submenuColor, singleOption })
            )}
          </Menu.ItemGroup>
        ))}
      </Menu>
    );
  };
  render() {
    const {
      app,
      // toggleOpenDrawer,
      height,
    } = this.props;
    const collapsed = clone(app.collapsed) && !clone(app.openDrawer);
    const customizedTheme = themes[themeConfig.theme];
    const styling = {
      backgroundColor: customizedTheme.backgroundColor,
    };
    const submenuStyle = {
      backgroundColor: "rgba(0,0,0,0.3)",
      color: customizedTheme.textColor,
    };
    const submenuColor = {
      color: customizedTheme.textColor,
    };
    const isMobile =
      app.view === "MobileView" ||
      (typeof window !== "undefined" && window.innerWidth <= 991);
    const showBackdrop = isMobile && !collapsed;

    const sidebarStyle = isMobile
      ? {
          ...styling,
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          height: "100vh",
          zIndex: 1001,
          transform: collapsed ? "translateX(-100%)" : "translateX(0)",
          transition: "transform 0.25s ease",
          visibility: collapsed ? "hidden" : "visible",
          pointerEvents: collapsed ? "none" : "auto",
          boxShadow: collapsed ? "none" : "4px 0 20px rgba(0,0,0,0.25)",
        }
      : styling;

    return (
      <SidebarWrapper>
        {/* {showBackdrop && (
          <div
            className="sidebar-mobile-backdrop"
            onClick={this.props.toggleCollapsed}
          />
        )} */}
        <Sider
          trigger={null}
          collapsible={true}
          collapsed={collapsed}
          width={250}
          className={`isomorphicSidebar${isMobile ? " is-mobile" : ""}`}
          style={sidebarStyle}
        >
          <div className="sidebar-logo-area">
            {collapsed ? (
              <img
                src={this.props.logoPath || require("../../image/dpo-images/Privezi-Logo.png")}
                className="sidebar-logo-collapsed"
                alt="logo"
                onError={(e) => { e.target.src = require("../../image/dpo-images/Privezi-Logo.png"); }}
              />
            ) : (
              <img
                src={this.props.logoPath || require("../../image/dpo-images/Privezi-Logo.png")}
                className="sidebar-logo-full"
                alt="logo"
                onError={(e) => { e.target.src = require("../../image/dpo-images/Privezi-Logo.png"); }}
              />
            )}
            {isMobile && (
              <button
                type="button"
                aria-label="Close menu"
                className="sidebar-close-btn"
                onClick={this.props.toggleCollapsed}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="6" y1="6" x2="18" y2="18" />
                  <line x1="6" y1="18" x2="18" y2="6" />
                </svg>
              </button>
            )}
          </div>
          <Scrollbars style={{ height: height - 100 }}>
            {this.renderGroupedMenu({ submenuStyle, submenuColor })}
          </Scrollbars>

          <div className="sidebar-footer">Version 1.1 Powered By Astrika.</div>
        </Sider>
      </SidebarWrapper>
    );
  }
}

export default connect(
  (state) => ({
    app: state.App,
    height: state.App.height,
    logoPath:
      state.Auth &&
      state.Auth.credentials &&
      state.Auth.credentials.data &&
      state.Auth.credentials.data.companyDetails &&
      state.Auth.credentials.data.companyDetails.logoPath,
  }),
  { toggleOpenDrawer, changeOpenKeys, changeCurrent, toggleCollapsed }
)(Sidebar);
